import { Button, Tooltip } from "@scuf/common";
import { DataTable } from "@scuf/datatable";
import { v4 as uuidv4 } from "uuid";
import { customToast } from "../../../../../../App";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../common/store/combinedReducer";
import _ from "lodash";
import { getSearchData, setLoading } from "../../../../../store/action";
import { useEffect } from "react";
import {
  checkFileAndFolder,
  getInitalPathName,
} from "../../../../../../common/utility/dataManagementUtils";
const ReactToastify = require("react-toastify");

export const DataManagementGridNew = (props: any) => {
  const dispatch = useDispatch();
  const {
    // pathcount,
    finallist,
    // paths,
    xval,
    newFileKey,
    inputEle,
    newArr,
    selectedRowData,
    selectedRow,
    isNewFolderBtnDisabled,
    showProgress,
    showReset,
    disablefuncupload,
    disablefunc,

    // Methods
    setSelectedRow,
    setSelectedRowData,
    setDownloadSelectedRowData,
    setDisablefunc,
    setDisablefuncUpload,
    setIsNewFolderBtnDisabled,
    setxval,

    // reset
    setfileKey,
    handlechangelink,
    setemptyFldrName,
    setFexist,
    dateFormatFun,
    setNameLength,
    setNewArr,
    setDeleteOpen,
    eventBeforeUploadApi,
    refreshCurrentPageOfTable,
    fileInputRef,
    setShowPopup,

    // search
    setFilteredGridData,
    filteredGridData,
    setIsSearchDataEmpty,
    isSearchDataEmpty,
    setSearchValue,
    searchValue,

    // download
    showDownloadProgress,
    setDownHandelClick,

    searchError,
  } = props;

  const tdata = useSelector((state: AppState) => {
    return state.reducer?.tableData;
  });

  const userDetail: any = useSelector((state: AppState) => {
    return state.reducer.userInfo;
  });

  const handleselection = (e: any) => {
    const isInProgress = _.find(e, ["status", "FILE_UPLOAD_INPROGRESS"]);
    // if (isNull(e[pathcount]?.path)) {
    //   const pathsss = finallist.join("/");
    //   paths.push(pathsss);
    // } else {
    //   paths.push(e[pathcount]?.path);
    // }
    // setPathcount(pathcount + 1);
    // setPaths(paths);
    setSelectedRow(e);
    setSelectedRowData(e);
    setDownloadSelectedRowData(e);
    if (isInProgress !== undefined || e.length === 0) {
      setDisablefunc(true);
      setDisablefuncUpload(false);
    } else {
      setDisablefunc(false);
      setDisablefuncUpload(true);
    }
  };

  const handleChangeFileName = (e: any, id: any) => {
    const newData = xval?.map((item: any) => {
      // TODO: this is slowing down client side execution (can be improved)
      if (item?.id === id) {
        const path = e.target.value
          .toString()
          .trimStart()
          .replace(/[^\w]/g, ""); // .replace(/[^a-zA-Z0-9_\s]|(?!\s)\s+/g, '');
        // .replace(/[^\w]/g, '');// .replace(/[\\\/?:*'<>|]/gi, '');
        path
          ? setIsNewFolderBtnDisabled(false)
          : setIsNewFolderBtnDisabled(true);
        return {
          ...item,
          path,
        };
      } else {
        return {
          ...item,
        };
      }
    });

    setxval(newData);
  };

  const handleKeyDown = (e: any) => {
    if (
      checkFileAndFolder(
        e.target.value,
        newArr,
        setemptyFldrName,
        setNameLength,
        setFexist
      ) === false
    ) {
      setfileKey("");
      e.preventDefault();
    }
  };

  function rendererNameColSearch(cellData: any) {
    let currentPath = `${finallist.join("/")}`;
    let currFolder = cellData?.rowData?.path.replace(
      new RegExp(`^${currentPath}\\s*`),
      ""
    );
    let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
    return cellData?.rowData?.path || cellData?.rowData?.path === "" ? (
      <Tooltip
        element={
          <div className="ellip">{cellData?.rowData?.fileName?.trimEnd()}</div>
        }
        content={cellData?.rowData?.fullPath}
        header={cellData?.rowData?.fileName}
        size="small"
        position="bottom left"
        data-testid="file-name"
      />
    ) : newFileKey !== cellData?.rowData?.id ? (
      <Tooltip
        element={
          <a onClick={() => handlechangelink(cellData?.rowData, tdata)}>
            <div className="ellip">{_currTopLevelFolder}</div>
          </a>
        }
        data-testid="navigate-to-folder-search"
        content={_currTopLevelFolder}
        position="bottom left"
      />
    ) : (
      <input
        ref={inputEle}
        name={"fileName"}
        value={cellData?.rowData?.path}
        onChange={(e) => handleChangeFileName(e, cellData?.rowData?.id)}
        onKeyDown={(e: any) => e.key === "Enter" && handleKeyDown(e)}
        onBlur={handleKeyDown}
        className="new-folder"
        autoFocus
        data-testid="create-new-folder-search"
      />
    );
  }
  function rendererNameColNoSearch(cellData: any) {
    let currentPath = `${finallist.join("/")}/`;
    let currFolder = cellData.rowData.path.replace(
      new RegExp(`^${currentPath}\\s*`),
      ""
    );
    let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
    return cellData.rowData.fileType === "folder" ? (
      newFileKey !== cellData.rowData.id ? (
        <Tooltip
          element={
            <a onClick={() => handlechangelink(cellData.rowData, tdata)}>
              <div className="ellip">{_currTopLevelFolder}</div>
            </a>
          }
          content={_currTopLevelFolder}
          position="bottom left"
          data-testid="navigate-to-folder-nosearch"
        />
      ) : (
        <input
          ref={inputEle}
          name={"fileName"}
          value={cellData.rowData.path}
          onChange={(e) => handleChangeFileName(e, cellData.rowData.id)}
          onKeyDown={(e: any) => e.key === "Enter" && handleKeyDown(e)}
          onBlur={handleKeyDown}
          data-testid="create-new-folder-nosearch"
          className="new-folder"
          autoFocus
        />
      )
    ) : (
      <Tooltip
        element={
          <div className="ellip">{cellData.rowData.fileName.trimEnd()}</div>
        }
        content={cellData.rowData.fullPath}
        header={cellData.rowData.fileName}
        size="small"
        position="bottom left"
        data-testid="file-name-nosearch"
      />
    );
  }
  const statusRendererUpdatedBy = (cellData: any) => {
    return (
      <Tooltip
        element={<div className="ellip">{cellData.rowData.updatedBy}</div>}
        content={cellData.rowData.updatedBy}
        position="bottom left"
      />
    );
  };
  const rendererPath = (cellData: any) => {
    return isSearchDataEmpty ? (
      <Tooltip
        element={<div className="ellip">{}</div>}
        content={cellData.rowData.path}
        position="bottom left"
      />
    ) : (
      <Tooltip
        element={<div className="ellip">{cellData.rowData.path}</div>}
        content={cellData.rowData.path}
        position="bottom left"
      />
    );
  };
  const rendererFileSizeCol = (cellData: any) => {
    if (!cellData.rowData.fileSize) return <></>;
    else if (
      (isSearchDataEmpty && cellData.rowData.fileType === "folder") ||
      cellData.rowData.status === "FILE_UPLOAD_INPROGRESS"
    )
      return <></>;
    else {
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(cellData.rowData.fileSize) / Math.log(k));
      let value: any = (cellData.rowData.fileSize / Math.pow(k, i)).toFixed(4);
      if (value % 1 === 0) {
        value = cellData.rowData.fileSize / Math.pow(k, i);
      } else {
        value = (cellData.rowData.fileSize / Math.pow(k, i)).toFixed(2);
      }
      return (
        <p>
          {value} {sizes[i]}
        </p>
      );
    }
  };

  // function checkFilenFolder(name: any) {
  //   const folderPresent = newArr.find(
  //     (folder: any) =>
  //       folder?.path?.trimEnd().toLowerCase() === name.trimEnd().toLowerCase()
  //   );
  //   if (name.length === 0) {
  //     setemptyFldrName(true);
  //     return true;
  //   } else if (name.length > 100) {
  //     setNameLength(true);
  //     return true;
  //   }
  //   if (folderPresent) {
  //     setFexist(true);
  //     return true;
  //   } else {
  //     setFexist(false);
  //     return false;
  //   }
  // }

  // const getInitalPathName = () => {
  //   const newFolderName = "My_folder";
  //   const folderNames: String[] = [];
  //   if (xval.length > 0) {
  //     xval.forEach((item: any) => {
  //       if (item.path.includes("/") || item.path === "") {
  //         return "/";
  //       } else {
  //         folderNames.push(item.path);
  //       }
  //     });
  //   }
  //   if (folderNames.length > 0) {
  //     let count = 1;
  //     while (true) {
  //       if (folderNames.includes(newFolderName + `_${count}`)) {
  //         count++;
  //       } else {
  //         return newFolderName + `_${count}`;
  //       }
  //     }
  //   } else {
  //     return newFolderName;
  //   }
  // };
  const date = new Date();
  const isoDate = dateFormatFun(date);
  const randomId = uuidv4();

  const newbody: any = {
    containerFolder: "New folder",
    containerName: "dpdevsitestorage",
    createdAt: "2023-09-19T07:47:02.7202602Z",
    createdBy: "NeutralNodeFolder",
    eTag: null,
    fileModifiedAt: "2023-09-15T09:54:51.3399924Z",
    fileName: null,
    fileSize: "",
    fileType: "folder",
    hashValue: "A219ADEDFACC25149BC49613E66B2D0A",
    id: randomId,
    partitionKey: "1920d035-749f-49ae-aae1-b5a4bfb572de",
    path: getInitalPathName(xval), // `New folder ${timestamp}`,
    source: "Web",
    rowKey: "9a87576e-4dde-49fe-823e-89e38cbb57af",
    status: "",
    timestamp: "",
    updatedAt: isoDate,
    updatedBy: userDetail?.email,
  };
  const handleCreateNewFolder = () => {
    setfileKey(newbody?.id);
    setxval([newbody, ...xval]);
    setNewArr([...xval]);
  };
  const handletoastdownload = () => {
    customToast(
      "File download started. Please wait for it to complete",
      "information"
    );
    setDownHandelClick(true);
  };

  const handletoastdelete = async () => {
    if (selectedRowData?.length > 0) {
      setDeleteOpen(true);
    } else {
      // ReactToastify.toast(<ToastNotificationdelete />)
      customToast("Please select file name", "critical");
    }
  };

  const statusRender = (e: any) => {
    switch (e.value) {
      case "FILE_UPLOAD_FAILED":
        return "File Upload Failed";
      case "FILE_UPLOAD_INPROGRESS":
        return "File Upload Inprogress";
      default:
        return e.value;
    }
  };

  const handleSearchInputTextBox = (e: any) => {
    if (e !== "") {
      // newData = xval.filter((item: any) => {
      //   if (
      //     item.fileName &&
      //     item.fileName.toLowerCase().includes(e.toLowerCase())
      //   ) {
      //     return true;
      //   } else if (
      //     item.path &&
      //     item.path.toLowerCase().includes(e.toLowerCase())
      //   ) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // });
      setFilteredGridData(filteredGridData);
      // setIsSearchDataEmpty(false);
      setSearchValue(e);
      if (/[\\/:*?"<>|]/.test(e)) {
        searchError.current = true;
      } else {
        searchError.current = false;
      }
    } else {
      let currentPath = `${finallist.join("/")}`;
      let folders = new Set();
      var _filteredData = xval?.filter((item: any) => {
        if (item.path === currentPath || item.path === undefined) {
          //item.path = undefined;
          item.fullPath = item.path + "/" + item.fileName;
          return item;
        } else {
          let currFolder = item.path.replace(
            new RegExp(`^${currentPath}\\s*`),
            ""
          );
          let _currTopLevelFolder = currFolder.split("/").filter(Boolean)[0];
          if (!folders.has(_currTopLevelFolder)) {
            folders.add(_currTopLevelFolder);
            item.fileType = "folder";
            // item.fileName=undefined;
            return item;
          }
        }
      });
      searchError.current = false;
      setSearchValue(e);
      setFilteredGridData(_filteredData);
      setIsSearchDataEmpty(true);
    }
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowPopup(false);
    window.removeEventListener("focus", handleFocusBack);
    eventBeforeUploadApi(event);
  };

  const handleFocusBack = () => {
    setShowPopup(false);
    window.removeEventListener("focus", handleFocusBack);
  };
  const clickedFileInput = () => {
    window.addEventListener("focus", handleFocusBack);
  };
  return (
    <div className="table-wrapper-custom">
      {
        <div data-testid="data-management-grid">
          <DataTable
            data={filteredGridData} // ?.length > 0 ? filteredGridData : xval}
            search={true}
            // data={tabledatas}
            rows={filteredGridData?.length}
            scrollable={true}
            totalItems={filteredGridData?.length}
            // paginate = {true}
            searchPlaceholder="Search on press of enter"
            globalFilterValue={searchValue}
            selection={selectedRow}
            selectionMode="multiple"
            // onSelectAll={handleselectall}
            showHeader={true}
            scrollHeight="45vh"
            virtualRowHeight={32}
            onSelectionChange={(e) => handleselection(e)}
            resizableColumns={true}
            data-testid="data-management-grid-data"
            onGlobalFilter={(e) => handleSearchInputTextBox(e)}
          >
            <DataTable.HeaderBar>
              <div>
                <Tooltip
                  element={
                    <Button
                      type="primary"
                      className={`item-newfolder ${
                        isNewFolderBtnDisabled || !isSearchDataEmpty
                          ? "disabled"
                          : ""
                      }`}
                      textTransform={false}
                      iconRoot="common"
                      icon="slidercontrols-plus"
                      content="New Folder"
                      size="small"
                      onClick={handleCreateNewFolder}
                      iconPosition="left"
                      disabled={isNewFolderBtnDisabled || !isSearchDataEmpty}
                    />
                  }
                  content="Create a new folder"
                />
              </div>

              <div className="datatable-menu-item">
                {showProgress ? (
                  <div className="upload-and-scan">
                    <p>Please don't refresh while upload is in-progress</p>
                  </div>
                ) : showDownloadProgress ? (
                  <div className="upload-and-scan">
                    <p>Please don't refresh while download is in-progress</p>
                  </div>
                ) : searchError?.current ? (
                  <div className="error-message">
                    <p>{`Search can't contain any of the following characters: / \\ : * ? " < > |`}</p>
                  </div>
                ) : (
                  <div className=" refresh-button">
                    <Tooltip
                      element={
                        <i
                          className="h-icon global refresh refresh-user-list scuf-medium"
                          data-testid="data-management-refresh-icon"
                          title=""
                          aria-label=""
                          onClick={() => {
                            setSearchValue("");
                            refreshCurrentPageOfTable();
                            handleSearchInputTextBox("");
                          }}
                        ></i>
                      }
                      content="Refresh"
                      position="bottom left"
                      size="mini"
                    />
                  </div>
                )}
                <Tooltip
                  element={
                    <Button
                      type="primary"
                      disabled={
                        showDownloadProgress ||
                        disablefuncupload ||
                        showReset ||
                        showProgress ||
                        !isSearchDataEmpty
                      }
                      textTransform={false}
                      className={
                        showDownloadProgress ||
                        disablefuncupload ||
                        showReset ||
                        showProgress ||
                        !isSearchDataEmpty
                          ? "item-uploaddisable-datamngmnt"
                          : "item-upload-datamngmnt"
                      }
                      iconRoot="global"
                      icon="file-upload"
                      content="Upload"
                      iconPosition="left"
                      size="small"
                      data-testid="upload-file-input"
                      onClick={() => setShowPopup(true)}
                    >
                      Upload
                      <input
                        id="browse-file"
                        data-testid="upload-file-input-file"
                        type="file"
                        title="uploadfile"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        className={
                          showDownloadProgress ||
                          disablefuncupload ||
                          showReset ||
                          showProgress ||
                          !isSearchDataEmpty
                            ? "item-uploaddisable-datamngmnt"
                            : "item-upload-datamngmnt"
                        }
                        disabled={
                          showDownloadProgress ||
                          disablefuncupload ||
                          showReset ||
                          showProgress ||
                          !isSearchDataEmpty
                        }
                        onChange={handleFileUpload}
                        onClick={clickedFileInput}
                      />
                    </Button>
                  }
                  content={`Upload files for all VM' S to Access`}
                  position="bottom left"
                  size="mini"
                />
                <Tooltip
                  element={
                    <Button
                      type="primary"
                      textTransform={false}
                      disabled={
                        disablefunc || showProgress || showDownloadProgress
                      }
                      className={
                        disablefunc || showProgress || showDownloadProgress
                          ? "button-disabled"
                          : "button-enabled"
                      }
                      // className='disabled-button-cursor'
                      iconRoot="global"
                      icon="file-download"
                      content="Download"
                      iconPosition="left"
                      size="small"
                      onClick={handletoastdownload}
                    />
                  }
                  content="Download the selected items to this PC"
                  position="bottom left"
                  size="mini"
                />
                <Tooltip
                  element={
                    <Button
                      type="primary"
                      style={{ marginLeft: "5px" }}
                      disabled={showDownloadProgress || disablefunc}
                      textTransform={false}
                      className={
                        showDownloadProgress || disablefunc || showProgress
                          ? "button-disabled"
                          : "button-enabled"
                      }
                      iconRoot="common"
                      icon="delete"
                      content="Delete"
                      iconPosition="left"
                      size="small"
                      onClick={handletoastdelete}
                    />
                  }
                  content="Delete the selected items across VMs"
                  position="bottom right"
                  size="mini"
                />
              </div>
            </DataTable.HeaderBar>
            <DataTable.Column
              field="fileName"
              className="name cell-crsr-pntr"
              header="Name"
              sortable={true}
              initialWidth="130px"
              renderer={
                isSearchDataEmpty
                  ? rendererNameColNoSearch
                  : rendererNameColSearch
              }
            />

            {/* <DataTable.Column field='fileType' header='Type' sortable={true} initialWidth='80px' renderer={statusRendererfiletype}/> */}
            <DataTable.Column
              field="path"
              header="Path"
              sortable={true}
              initialWidth={isSearchDataEmpty ? "0px" : "120px"}
              renderer={rendererPath}
            />
            {/* <DataTable.Column field='path' header='Path' sortable={true} initialWidth='120px'/> */}

            <DataTable.Column
              field="fileSize"
              header="File Size"
              className="file"
              sortable={true}
              initialWidth="80px"
              renderer={rendererFileSizeCol}
            />
            <DataTable.Column
              field="source"
              header="Source"
              sortable={true}
              initialWidth="80px"
            />
            <DataTable.Column
              field="updatedAt"
              header="Last Modified On"
              sortable={true}
              initialWidth="100px"
            />

            <DataTable.Column
              field="updatedBy"
              header="Last Modified By"
              sortable={true}
              initialWidth="178px"
              className="cell-crsr-pntr"
              renderer={statusRendererUpdatedBy}
            />
            <DataTable.Column
              field="status"
              header="Status"
              sortable={true}
              initialWidth="80px"
              renderer={(e) => statusRender(e)}
            />
            {/* <DataTable.Pagination 
                totalItems = {filteredGridData.length}
                itemsPerPage= {itemsPerPage}
            /> */}
            {/* <DataTable.Column
                          field='' header=''
                          renderer={(e) => statusRendererRowFileRename(e)}
                          initialWidth='50px' /> */}
          </DataTable>
          <ReactToastify.ToastContainer
            hideProgressBar={true}
            closeOnClick={true}
            closeButton={false}
            newestOnTop={true}
            position="top-left"
            toastClassName="toast-notification-wrap"
            theme="none"
            margin-left="100px"
          />
        </div>
      }
    </div>
  );
};
